import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { Dayjs } from 'dayjs';
import { TimeZone } from '../../../time/timezone.js';
import { TrueTime } from '../../../time/true-time.js';

export class EventShortCode extends DataModel {
  static readonly TYPE_ID: string = '9b6fc4efc4e849d4ae7c3d4dcc84cab8';

  private constructor(
    public readonly uniqueId: string,
    public readonly businessRef: BusinessModuleRef,
    public readonly eventId: string,
    public readonly creationDate: Dayjs,
  ) {
    super();
  }

  get $typeId(): string {
    return EventShortCode.TYPE_ID;
  }

  static create(args: {
      uniqueId: string,
      businessRef: BusinessModuleRef,
      eventId: string,
  }): EventShortCode {
    return new EventShortCode(args.uniqueId, args.businessRef, args.eventId, TrueTime.now());
  }

  static fromMap(context: SerializationContext, map: SerializedData): EventShortCode {
    return new EventShortCode(
        MapUtils.get<string>(map, 'uniqueId'),
        BusinessModuleRef.mustDecode(MapUtils.get<string>(map, 'businessRef')),
        MapUtils.get<string>(map, 'eventId'),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'businessRef': this.businessRef.encode(),
      'eventId': this.eventId,
      'creationDate': context.encodeDate(this.creationDate),
    };
  }

  clone(): this {
    return new EventShortCode(
        this.uniqueId,
        this.businessRef.clone(),
        this.eventId,
        TimeZone.cloneDate(this.creationDate),
    ) as this;
  }

  isSame(other: this): boolean {
    if(this === other) {
      return true;
    }

    return this.uniqueId === other.uniqueId &&
        this.businessRef.isSame(other.businessRef) &&
        this.creationDate == other.creationDate &&
        this.eventId === other.eventId;
  }
}

export class EventShortCodeBuilder extends DataModelBuilder<EventShortCode> {
  build(context: SerializationContext, map: SerializedData): EventShortCode {
    return EventShortCode.fromMap(context, map);
  }
}
